import { Component, Input, ElementRef, EventEmitter, Output, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpEventType } from '@angular/common/http';
declare var $: any;

@Component({
    selector: 'ups-dashboard-accordeon-det',
    template: require('./ups-dashboard-accordeon-det.component.html'),
    encapsulation: ViewEncapsulation.None
})
export class UpsDashboardAccordeonDetComponent {

    public toogleMenu: boolean = false;
    public displayCard: string = 'none';
    @Input() title: string = '';

    toggle() {
        this.toogleMenu = !this.toogleMenu;

        if (this.title !== '') {
            this.displayCard = this.toogleMenu ? 'block' : 'none';
        }
    }

}


